import React from 'react';
import { css } from 'linaria';
import cn from 'clsx';

import NavGroupContent from './NavGroupContent';

const GridRowsMaxContent = css`
  grid-template-rows: max-content;
`;
const NavColumns = [
  css`
    grid-template-columns: repeat(1, minmax(120px, 160px));
  `,
  css`
    grid-template-columns: repeat(2, minmax(120px, 160px));
  `,
  css`
    grid-template-columns: repeat(3, minmax(120px, 160px));
  `,
  css`
    grid-template-columns: repeat(4, minmax(120px, 160px));
  `,
  css`
    grid-template-columns: repeat(5, minmax(120px, 160px));
  `,
];

const SectionContent = (props: any) => {
  const { childNodes, navLevel, onNavFinished } = props;

  const numCols = Math.min(4, childNodes.length - 1);
  const hasTwoRows = childNodes.length > 5;
  const ColumnCSSClass = NavColumns[numCols];

  return (
    <div className={cn('grid gap-5 grid-rows-max-content', GridRowsMaxContent, ColumnCSSClass)}>
      {childNodes.map((childNode: any, index: number) => {
        const hasContentBelow = hasTwoRows && index < 5 && index < childNodes.length - 4;
        const spansTwoCols = hasContentBelow && index < childNodes.length - 5;
        return (
          <NavGroupContent
            childNodes={childNode.childNodes}
            className={spansTwoCols ? undefined : 'row-span-2'}
            hasContentBelow={hasContentBelow}
            key={childNode.id}
            navLevel={navLevel}
            node={childNode}
            onNavFinished={onNavFinished}
          />
        );
      })}
    </div>
  );
};

export default React.memo(SectionContent);
